import _ from 'lodash';
export var titleCase = function (text) { return _.startCase(_.toLower(text)); };
